import { Navigate, useParams } from 'react-router';
import { DrawdownMatrixView } from '@/components/drawdowns/drawdown-matrix/DrawdownMatrixView';

export default function DrawdownMatrixPage() {
  const { fundId } = useParams<{ fundId: string }>();

  if (!fundId) {
    return <Navigate to="/app/funds" replace />;
  }

  return <DrawdownMatrixView fundId={fundId} />;
}
